const selector = {
    checkoutForm: '#form_checkout',
    checkTerms: '#check_terms',
    serialNumber: '#tag_serial_number',
    registrationPlate: '#registration_plate',
    verificationCode: '#tag_verification_code',
    btn: {
        submit: '#btn_submit'
    },
    form: {
        customerType: 'input[name="customer_type"]',
        customerTypeChecked: 'input[name="customer_type"]:checked',
        customer: {
            cardholderName: '#cardholder_name',
            cardholderSurname: '#cardholder_surname',
        },
        business: {
            companyName: '#company_name',
            mb: '#mb',
            pib: '#pib',
        },
        businessForeign: {
            companyName: '#company_name',
            country: '#country',
            pib: '#pib',
        },
    },
};

export {selector};